import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import frCommon from "./locales/fr/common.json";
import enCommon from "./locales/en/common.json";

export const defaultNS = "common";
export const resources = {
  fr: {
    common: frCommon,
  },
  en: {
    common: enCommon,
  },
} as const;

const getInitialLang = (): "fr" | "en" => {
  try {
    const saved = localStorage.getItem("seva_lang");
    if (saved === "en" || saved === "fr") {
      return saved;
    }
  } catch (e) {
    // ignore
  }
  return "fr";
};

const initialLang = getInitialLang();
document.documentElement.lang = initialLang;

i18n.use(initReactI18next).init({
  resources,
  lng: initialLang,
  fallbackLng: "fr",
  defaultNS,
  interpolation: {
    escapeValue: false,
  },
});

i18n.on("languageChanged", (lng: string) => {
  document.documentElement.lang = lng?.startsWith("en") ? "en" : "fr";
});

export default i18n;
